import React, { useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { NormalizedVoucher } from '@esportal/portal-service';
import { SalesforceVoucherDetail } from '../components/salesforce-voucher-detail/salesforce-voucher-detail';
import { PortalContext } from '../context/portal-context';
import { useUniversalEffect } from '@volkswagen-onehub/vw-starter-feature-app-support';
import { usePageTracker } from '../hooks/use-page-tracker';
import { cleanText, isVehicle } from '../helpers/common-helpers';
import { ClubVolkswagenPages, getClubVolkswagenPageInfo } from './model/club-volkswagen-pages-info';

export const SalesforceVoucherPage = ({ normalizedVouchers }: { normalizedVouchers: NormalizedVoucher[] }) => {
	const { pageInfoService, portalService } = React.useContext(PortalContext);

	const { id } = useParams<{ id: string }>();
	const voucher = id ? normalizedVouchers.find((v) => v.id === id) : undefined;
	if (!voucher) return null;

	const pageInfo = getClubVolkswagenPageInfo(ClubVolkswagenPages.SalesforceVoucherPage, {
		campaignId: voucher?.campaign ?? '',
		voucherTitle: cleanText(voucher?.card?.title ?? ''),
	});

	useUniversalEffect(() => {
		pageInfoService.setPageInfo({
			seo: { pageTitle: pageInfo.seoTitle },
		});
	}, [pageInfoService]);

	// devuelve un array con el vehículo correspondiente al VIN, o undefined si no se encuentra
	const getVoucherVehicles = useCallback(
		(vin?: string) => {
			if (!vin) return undefined;
			const vehicle = portalService.getVehicleOrOrderByVin(vin).getValue();
			return isVehicle(vehicle) ? [vehicle] : undefined;
		},
		[portalService],
	);

	usePageTracker({
		contentId: pageInfo.contentId,
		vehicle: getVoucherVehicles(voucher?.vin),
		isVoucherPage: true,
	});

	return <SalesforceVoucherDetail voucher={voucher} />;
};
